import rawData from "../data.json";
import { TrophyIcon } from "@heroicons/react/24/solid";

// Compute unweighted scores and assign ranks
const calculateScoresAndRanks = (data) => {
  const maxPass = 72; // total number of programs

  const scored = data.map((row) => {
    const passPercent = (row.numberPass / maxPass) * 100;
    const score = (passPercent + row.successProbability + row.completeness) / 3;
    return { ...row, passPercent, score };
  });

  const sorted = scored.sort((a, b) => b.score - a.score);

  return sorted.map((row, index) => ({ ...row, rank: index + 1 }));
};

const data = calculateScoresAndRanks(rawData);

const getRankIcon = (rank) => {
  const base = (
    <span className="flex items-center justify-center gap-1">
      <span>{rank}</span>
    </span>
  );
  if (rank === 1)
    return (
      <span className="flex items-center justify-center gap-1">
        <span>1</span>
        <TrophyIcon className="w-5 h-5 text-yellow-500" />
      </span>
    );
  if (rank === 2)
    return (
      <span className="flex items-center justify-center gap-1">
        <span>2</span>
        <TrophyIcon className="w-5 h-5 text-gray-400" />
      </span>
    );
  if (rank === 3)
    return (
      <span className="flex items-center justify-center gap-1">
        <span>3</span>
        <TrophyIcon className="w-5 h-5 text-orange-500" />
      </span>
    );
  return base;
};

export default function Leaderboard() {
  return (
    <div className="max-w-6xl mx-auto overflow-hidden bg-white border border-gray-300 rounded-lg shadow">
      <div className="overflow-x-auto">
        <table className="w-full text-sm table-auto sm:text-base">
          <thead className="font-semibold text-gray-700 border-b border-gray-200 bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-center">Rank</th>
              <th className="px-4 py-3 text-center">Technique</th>
              <th className="px-4 py-3 text-center">Model</th>
              <th className="px-4 py-3 text-center">Score</th>
              <th className="px-4 py-3 text-center"># Pass</th>
              <th className="px-4 py-3 text-center">Success Probability</th>
              <th className="px-4 py-3 text-center">Completeness</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <tr
                key={row.technique}
                // className="transition-colors border-b border-gray-100 hover:bg-gray-50"
                className={`transition-colors border-b border-gray-100 hover:bg-gray-50 ${
                  index === 0 ? "font-bold bg-yellow-50" : ""
                }`}
              >
                <td className="px-4 py-3 font-medium text-center align-middle">
                  {getRankIcon(row.rank)}
                </td>
                <td className="px-4 py-3 text-center align-middle">
                  {row.url ? (
                    <a
                      href={row.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="font-semibold text-blue-600 hover:underline"
                    >
                      {row.technique}
                    </a>
                  ) : (
                    <span className="font-semibold">{row.technique}</span>
                  )}
                </td>
                <td className="px-4 py-3 text-center text-gray-700 align-middle">
                  {row.model}
                </td>
                <td className="px-4 py-3 font-mono text-center text-gray-800 align-middle tabular-nums">
                  {row.score.toFixed(2)}%
                </td>
                <td className="px-4 py-3 font-mono text-center align-middle tabular-nums">
                  {row.numberPass}
                </td>
                <td className="px-4 py-3 font-mono text-center align-middle tabular-nums">
                  {row.successProbability.toFixed(2)}%
                </td>
                <td className="px-4 py-3 font-mono text-center align-middle tabular-nums">
                  {row.completeness.toFixed(2)}%
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
